import { createAction } from '@ngrx/store';

export const NotificationsCommonActions = {
  refreshNotificationsDrawer: createAction('[Notifications] Refresh Notifications Drawer')
};
